import React from "react";

import { Container, MainSection, CardMainText, Details } from "basics/cards";

import ItemCardToolBar from "components/ItemCardToolBar";

import TopicIcon from "icons/entities/TopicIcon";
import AwardIcon from "icons/entities/AwardIcon";

import { Link } from "wouter";

export default function TopicCard({
  item,
  selected,
  onSelectEditedItem,
  onSelectDeletedItem,
  onCleanItemId,
}) {
  return (
    <Container selected={selected}>
      <MainSection>
        <TopicIcon />
        <Details>
          <CardMainText>{item.title}</CardMainText>
        </Details>
      </MainSection>

      <ItemCardToolBar
        id={item.id}
        actived={item.actived}
        selected={selected}
        onCleanItemId={onCleanItemId}
        onSelectEditedItem={onSelectEditedItem}
        onSelectDeletedItem={onSelectDeletedItem}
      >
        <Link to={`/administracion/premios/${item.id}`}>
          <AwardIcon />
        </Link>
      </ItemCardToolBar>
    </Container>
  );
}
